/**
 * The cents an allocation's amounts add up to. Compared in cents, because 0,1 + 0,2 is not 0,3
 * in floating point and an allocation must add up to the net amount exactly.
 *
 * @param amounts - The rows' amounts in euros; an empty row counts as zero.
 * @returns The sum in cents.
 */
export function allocationCents(amounts: Array<number | null | undefined>) {
	let cents = 0;
	for (const amount of amounts) cents += Math.round((amount ?? 0) * 100);
	return cents;
}
